<div style="overflow-x:auto;" class="desktop-view">
  <div class="page-header">
    <div class="div-center">
      <h1>{{currentEvent?.name}}</h1>
    </div>
    <div class="div-center">
    <div *ngIf="isAdmin()">
      <button class="button-main-outline" (click)="openTagBib()">Tag-Bib</button>
    </div>
    <div>
      <button class="button-main-blue" routerLink="/events/{{currentEvent?.id}}/mass-assignment">
        <mat-icon>assignment</mat-icon>
        Массовое присвоение номеров
      </button>

      <button class="button-main-blue" (click)="onSubmitMassEdit()">
        <mat-icon>assignment</mat-icon>
        Массовое редактирование
      </button>
      <button class="button-main-blue" *ngIf="isAdmin()" (click)="onSubmitAssignCategories()">
        <mat-icon>assignment</mat-icon>
        Присвоение категорий
      </button>

      <button class="button-main-danger" *ngIf="isSuperUser()" (click)="clearTagBib()">
        <mat-icon>cleaning_services</mat-icon>
        Очищение tag-bib
      </button>
    </div>
    <button class="button-main-blue" (click)="openCreateParticipantDialog(createParticipantContent)" *ngIf="isAdmin()">
      <mat-icon>person_add</mat-icon>
      Добавить участника
    </button>
    <input type="file" class="button-main-outline" style="display: none" (change)="uploadCsv($event)"
           *ngIf="isAdmin()"/>
    <label class="button-main-outline" (click)="uploadCsv($event)" *ngIf="isAdmin()">
      <input id="upload-csv" style="display: none" (click)="openUploadCSV(uploadContent)">
<!--      type="file"-->
<!--             accept=".csv" -->
<!--             (change)="uploadCsv($event)"-->
<!--      >-->
      Upload CSV
    </label>
    <button class="button-main-blue" (click)="openDownloadCSV(content)" *ngIf="isAdmin()">Download CSV</button>
    <button class="button-main-blue" (click)="openStatisticsDialog(statisticsContent)" *ngIf="isAdmin()">Статистика
    </button>
    </div>
  </div>
  <!--  <div class="fullscreen-button-container">-->
  <!--    <button class="button-fullscreen-icon" (click)="toggleFullScreen()">-->
  <!--      <mat-icon>{{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>-->
  <!--    </button>-->
  <!--  </div>-->
  <div class="search-section">
    <div class="search-input-container">
      <input type="text" class="input-bib" placeholder=""
             [(ngModel)]="searchQuery"
             (ngModelChange)="search($event)"
             autofocus>
      <button *ngIf="searchQuery"
              type="button"
              class="clear-search-btn"
              (click)="clearSearch()"
              title="Очистить поиск">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <label class="label-gray">
      Для поиска по всем мероприятиям нужно ввести минимум {{ lengthForSearch }} символов.
      Поддерживается поиск по комбинации "Фамилия Имя" или "Имя Фамилия" (минимум 3 символа).
    </label>
  </div>

  <div class="table-container">
    <!-- Сообщение о пустом результате поиска -->
    <div *ngIf="showEmptyState" class="empty-search-container">
      <div class="empty-state">
        <mat-icon>search_off</mat-icon>
        <p>По запросу "{{ searchQuery }}" ничего не найдено</p>
        <button class="button-main-outline" (click)="clearSearch()">
          <mat-icon>refresh</mat-icon>
          Очистить поиск
        </button>
      </div>
    </div>

    <!-- Виртуализированное отображение для больших списков -->
    <cdk-virtual-scroll-viewport itemSize="50" class="virtual-scroll-viewport" *ngIf="participants.length > 500 && showTable">
      <table class="styled-table" *ngIf="isIssuanceEvent">
        <thead>
        <tr>
          <th>#</th>
          <th>Фамилия</th>
          <th>Имя</th>
          <th>Дата рождения</th>
          <th>Пол</th>
          <th>Клуб</th>
          <th>Телефон</th>
          <th>Категория</th>
          <th>Статус выдачи</th>
          <th>Действия</th>
        </tr>
        </thead>
        <tbody>
        <ng-container
          *cdkVirtualFor="let state of participants; trackBy: trackByParticipant;"
          style="background-color: #000000;">
          <tr
            (click)="openIssuanceDialog(issuanceContent, state)"
            style="cursor: pointer;"
            [ngClass]="{'no-entry-ticket': !hasEntryTicket(state)}">
            <td>{{ participants.indexOf(state) + 1 }}</td>
            <td>{{ state.surname }}</td>
            <td>{{ state.name }}</td>
            <td>{{ state.dateOfBirth }}</td>
            <td>{{ state.gender }}</td>
            <td>{{ getShortString(state.club) }}</td>
            <td>{{ state.phone }}</td>
            <td>{{ state.category }}</td>
            <td>
              <div class="issuance-status">
                <span *ngIf="getParticipantIssuanceStatus(state) === 'issued'" class="status-issued">
                  <mat-icon>check_circle</mat-icon> Выдано
                </span>
                <span *ngIf="getParticipantIssuanceStatus(state) === 'partially_issued'" class="status-partially-issued">
                  <mat-icon>warning</mat-icon> Частично выдано
                </span>
                <span *ngIf="getParticipantIssuanceStatus(state) === 'not_issued'" class="status-not-issued">
                  <mat-icon>schedule</mat-icon> Не выдано
                </span>
              </div>
            </td>
            <td>
              <button class="button-main-blue"
                      [disabled]="!canIssueNumbers(state)"
                      (click)="openIssuanceDialog(issuanceContent, state); $event.stopPropagation()">
                {{ hasEntryTicket(state) ? 'Выдать' : 'Нет билета' }}
              </button>
            </td>
          </tr>
        </ng-container>
        
        </tbody>
      </table>
    </cdk-virtual-scroll-viewport>

    <!-- Обычное отображение для небольших списков -->
    <table class="styled-table" *ngIf="isIssuanceEvent && participants.length <= 500 && showTable">
      <thead>
      <tr>
        <th>#</th>
        <th>Фамилия</th>
        <th>Имя</th>
        <th>Дата рождения</th>
        <th>Пол</th>
        <th>Клуб</th>
        <th>Телефон</th>
        <th>Категория</th>
        <th>Статус выдачи</th>
        <th>Действия</th>
      </tr>
      </thead>
      <tbody>
              <ng-container *ngFor="let participant of mergedParticipants | filterList: searchQuery; let i = index">
         <tr (click)="openIssuanceDialog(issuanceContent, participant)"
             style="cursor: pointer;"
             [ngClass]="{'no-entry-ticket': !hasEntryTicket(participant)}">
          <td>{{ i + 1 }}</td>
          <td>{{ participant.surname }}</td>
          <td>{{ participant.name }}</td>
          <td>{{ participant.dateOfBirth }}</td>
          <td>{{ participant.gender }}</td>
          <td>{{ getShortString(participant.club) }}</td>
          <td>{{ participant.phone }}</td>
          <td>{{ participant.category }}</td>
          <td>
            <div class="issuance-status">
              <span *ngIf="getParticipantIssuanceStatus(participant) === 'issued'" class="status-issued">
                <mat-icon>check_circle</mat-icon> Выдано
              </span>
              <span *ngIf="getParticipantIssuanceStatus(participant) === 'partially_issued'" class="status-partially-issued">
                <mat-icon>warning</mat-icon> Частично выдано
              </span>
              <span *ngIf="getParticipantIssuanceStatus(participant) === 'not_issued'" class="status-not-issued">
                <mat-icon>schedule</mat-icon> Не выдано
              </span>
            </div>
          </td>
                      <td>
             <button class="btn btn-primary btn-sm"
                     [disabled]="!canIssueNumbers(participant)"
                     [class.btn-danger]="!hasEntryTicket(participant)"
                     (click)="openIssuanceDialog(issuanceContent, participant); $event.stopPropagation()">
               {{ hasEntryTicket(participant) ? 'Выдать' : 'Нет билета' }}
              </button>
            </td>
        </tr>
      </ng-container>
      
      </tbody>
    </table>

    <!-- Обычное отображение для других типов мероприятий -->
    <table class="styled-table" *ngIf="!isIssuanceEvent && showTable">
      <thead>
      <tr>
        <th>#</th>
        <th *ngIf="isAdmin()">ID</th>
        <th>bib <i class="fa fa-sort" style="margin-left: 3px" aria-hidden="true" (click)="sortByBib()"></i></th>
        <th *ngIf="isAdmin()">tag</th>
        <th (click)="sortBySurname()">Фамилия <i class="fa fa-sort" style="margin-left: 3px" aria-hidden="true"></i>
        </th>
        <th>Имя <i class="fa fa-sort" style="margin-left: 3px" aria-hidden="true" (click)="sortByName()"></i></th>
        <th>Пол</th>
        <th *ngIf="isAdmin()">Клуб</th>
        <th *ngIf="isAdmin()">phone</th>
        <th>Дата рождения<i (click)="sortByBirthDate()" class="fa fa-sort" style="margin-left: 3px"
                            aria-hidden="true"></i></th>
        <th *ngIf="isAdmin()">category</th>
        <th *ngIf="isAdmin()">event <i class="fa fa-sort" style="margin-left: 3px" aria-hidden="true" (click)="sortByEvent()"></i></th>
        <th *ngIf="isAdmin()">start</th>
      </tr>
      </thead>
      <tbody>
      <ng-container
        *ngFor="let state of participants | filterList: searchQuery; trackBy: trackByParticipant;"
        style="background-color: #000000;">
        <tr
          (click)="openEditParticipantDialog(content2,state)"
          [ngClass]="{'tr-highlighted': state?.isFromOtherEvent}">
          <td>{{ participants.indexOf(state) + 1 }}</td>
          <td *ngIf="isAdmin()">{{ state?.id }}</td>
          <td>{{ state?.bib }}</td>
          <td *ngIf="isAdmin()">{{ state?.tag }}</td>
          <td>{{ state?.surname }}</td>
          <td>{{ state?.name }}</td>
          <td>{{ state?.gender }}</td>
          <td *ngIf="isAdmin()">{{ getShortString(state?.club) }}</td>
          <td *ngIf="isAdmin()">{{ state?.phone }}</td>
          <td>{{ state?.dateOfBirth }}</td>
          <td *ngIf="isAdmin()">{{ state?.category }}</td>
          <td *ngIf="isAdmin()">{{ state?.eventShortName }} {{ state?.event }}</td>
          <td *ngIf="isAdmin()">{{ getTimestamp(state?.estimatedStart) }}</td>
        </tr>
      </ng-container>
      
      </tbody>
    </table>
  </div>
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>

<!-- Мобильное представление (карточки) - видно только на мобильных -->
<div class="mobile-container">
  <div class="mobile-header">
    <h1 class="mobile-title">{{ currentEvent?.name }}</h1>
  </div>

  <div class="mobile-search">
    <div class="mobile-search-input-container">
      <input type="text" class="mobile-search-input"
             placeholder="Фамилия Имя или номер..."
             [(ngModel)]="searchQuery"
             (ngModelChange)="search($event)">
      <button *ngIf="searchQuery"
              type="button"
              class="mobile-clear-search-btn"
              (click)="clearSearch()"
              title="Очистить поиск">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Мобильные карточки для типа issuance -->
  <div class="mobile-cards" *ngIf="isIssuanceEvent">
    <div *ngFor="let participant of mergedParticipants | filterList: searchQuery; trackBy: trackByParticipant;"
         class="mobile-card"
         [ngClass]="{'mobile-no-entry-ticket': !hasEntryTicket(participant)}"
         (click)="openIssuanceDialog(issuanceContent, participant)">

      <div class="card-header">
        <span class="card-bib">{{ participant?.events?.length || 0 }} дистанции</span>
        <!-- Статус выдачи в мобильной версии -->
        <div class="mobile-issuance-status">
          <span *ngIf="getParticipantIssuanceStatus(participant) === 'issued'" class="mobile-status-issued">
            <mat-icon>check_circle</mat-icon>
          </span>
          <span *ngIf="getParticipantIssuanceStatus(participant) === 'partially_issued'" class="mobile-status-partially-issued">
            <mat-icon>warning</mat-icon>
          </span>
          <span *ngIf="getParticipantIssuanceStatus(participant) === 'not_issued'" class="mobile-status-not-issued">
            <mat-icon>schedule</mat-icon>
          </span>
        </div>
      </div>

      <div class="card-name">
        {{ participant?.surname }} {{ participant?.name }}
        <!-- Индикатор отсутствия входного билета -->
        <span *ngIf="!hasEntryTicket(participant)" class="mobile-no-ticket-indicator">
          <mat-icon>error</mat-icon>
        </span>
      </div>

      <div class="card-details">
        <div>
          <mat-icon>cake</mat-icon>
          {{ participant?.dateOfBirth }}
        </div>
        <div>
          <mat-icon>schedule</mat-icon>
          {{ participant?.category }}
        </div>
        <div *ngIf="participant?.club">
          <mat-icon>group</mat-icon>
          {{ participant.club }}
        </div>
        <div>
          <mat-icon>event</mat-icon>
          {{ participant?.events?.join(', ') }}
        </div>
        <!-- Показываем все номера участника в мобильной версии -->
        <div *ngIf="participant.allBibNumbers && participant.allBibNumbers.length > 0" class="mobile-bib-numbers">
          <mat-icon>confirmation_number</mat-icon>
          <span *ngFor="let bibItem of participant.allBibNumbers; let last = last; trackBy: trackByBibNumber;" class="mobile-bib-item"
                [class.mobile-bib-issued]="bibItem.issuanceStatus === 'issued'">
            {{ bibItem.bib || 'Нет номера' }} ({{ bibItem.event }}){{ !last ? ', ' : '' }}
          </span>
        </div>
      </div>

      <div class="card-actions">
        <button class="btn btn-sm"
                [class.btn-primary]="hasEntryTicket(participant)"
                [class.btn-danger]="!hasEntryTicket(participant)"
                [disabled]="!canIssueNumbers(participant)"
                (click)="openIssuanceDialog(issuanceContent, participant); $event.stopPropagation()">
          {{ hasEntryTicket(participant) ? 'Выдать' : 'Нет билета' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Обычные мобильные карточки для других типов мероприятий -->
  <div class="mobile-cards" *ngIf="!isIssuanceEvent">
    <div *ngFor="let participant of participants | filterList: searchQuery; trackBy: trackByParticipant;"
         class="mobile-card"
         (click)="openEditParticipantDialog(editParticipantContent, participant)">

      <div class="card-header">
        <span class="card-bib">{{ participant?.bib || 'Нет номера' }}</span>
      </div>

      <div class="card-name">
        {{ participant?.surname }} {{ participant?.name }}
      </div>

      <div class="card-details">
        <div>
          <mat-icon>event</mat-icon>
          {{ participant?.eventShortName || participant?.event }}
        </div>
        <div>
          <mat-icon>schedule</mat-icon>
          {{ participant?.category }}
        </div>
        <div>
          <mat-icon>cake</mat-icon>
          {{ participant?.dateOfBirth }}
        </div>
        <div *ngIf="participant?.club">
          <mat-icon>group</mat-icon>
          {{ participant.club }}
        </div>
      </div>

      <div class="card-status" *ngIf="participant?.isFromOtherEvent">
        <mat-icon>warning</mat-icon>
        Другое мероприятие
      </div>
    </div>
  </div>
</div>

<ng-template #content2 let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Редактирование участника
    </h4>

    <button type="button" class="btn btn-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">

      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <!--        <h4> {{currentEvent.name}}</h4>-->

        <h5 *ngIf="!isAdmin()">
          {{ participantToEdit?.surname }} {{ participantToEdit.name }}
        </h5>
        <h6>Мероприятие: {{ participantToEdit?.eventName }}</h6>
        <h6 *ngIf="participantToEdit?.isFromOtherEvent" class="text-highlighted-alert">УЧАСТНИК ЗАРЕГИСТРИРОВАН НА
          ДРУГОЕ МЕРОПРИЯТИЕ</h6>
        <!--        <h6 *ngIf="!isAdmin()">Клуб: {{getStringIfEmpty(participantToEdit.club)}}</h6>-->
        <h6 *ngIf="!isAdmin()">Дистанция: {{ getStringIfEmpty(participantToEdit.event) }}</h6>
        <h6 *ngIf="!isAdmin()">Дата рождения: {{ getStringIfEmpty(participantToEdit.dateOfBirth) }}</h6>
        <h6 *ngIf="!isAdmin()">Категория: {{ getStringIfEmpty(participantToEdit.category) }}</h6>
        <h6 *ngIf="!isAdmin()">Номер телефона: {{ getStringIfEmpty(participantToEdit.phone) }}</h6>
        <h6>Старт: {{ getStartForParticipant(participantToEdit) }}</h6>
        <h6>Окончание выдачи: {{ getEndOfflineRegistrationTime(participantToEdit) }}</h6>
        <!--        <label class="label-black">ID</label>-->
        <!--        <input name="punch-id" class="form-control" onfocus="blur();" readonly="readonly" style="color: #787878;"-->
        <!--               [(ngModel)]="participantToEdit.name" [contentEditable]="false">-->

        <label class="label-black" *ngIf="canEdited()">Номер участника</label>
        <input id="input-bib" name="bib" class="form-control" type="number" [disabled]="!canEdited()"
               *ngIf="canEdited()"
               [(ngModel)]="participantToEdit.bib" [autofocus]="true">

        <div *ngIf="isAdmin()">
          <label class="label-black">Tag</label>
          <input name="tag" class="form-control" type="text" [disabled]="!isAdmin()"
                 [(ngModel)]="participantToEdit.tag" [contentEditable]="false">
        </div>

        <div *ngIf="isAdmin()">
          <label class="label-black">Фамилия</label>
          <input name="surname" class="form-control"
                 [(ngModel)]="participantToEdit.surname">
        </div>
        <div *ngIf="isAdmin()">
          <label class="label-black">Имя</label>
          <input name="name" class="form-control"
                 [(ngModel)]="participantToEdit.name">
        </div>
        <div *ngIf="isAdmin()">
          <label class="label-black">Клуб</label>
          <input name="club" class="form-control"
                 [(ngModel)]="participantToEdit.club">
        </div>
        <div *ngIf="isAdmin()">
          <label class="label-black">Дата рождения</label>
          <input name="dateOfBirth" class="form-control"
                 [(ngModel)]="participantToEdit.dateOfBirth">
        </div>

        <div *ngIf="isAdmin()">
          <label class="label-black">Пол</label>
          <select class="form-control" id="selected-gender" [(ngModel)]="participantToEdit.gender"
                  name="selected-gender" [disabled]="!isAdmin()">
            <option *ngFor="let c of genders" [ngValue]="c">{{ c }}</option>
          </select>
        </div>

        <div *ngIf="isAdmin()">
          <label class="label-black">Категория</label>
          <!--          <input name="category" class="form-control"-->
          <!--                 [(ngModel)]="participantToEdit.category"-->
          <!--                 onfocus="blur();" readonly="readonly"-->
          <!--                 style="color: #787878; background: #efefef"-->
          <!--          >-->

          <select class="form-control" id="selected-category" [(ngModel)]="participantToEdit.category"
                  name="selected-category" [disabled]="!isAdmin()">
            <option *ngFor="let c of categories" [ngValue]="c">{{ c }}</option>
          </select>
        </div>

        <div *ngIf="isAdmin()">
          <label class="label-black">Event</label>
          <!--          <input name="event" class="form-control"-->
          <!--                 [(ngModel)]="participantToEdit.event"-->
          <!--                 onfocus="blur();" readonly="readonly"-->
          <!--                 style="color: #787878; background: #efefef"-->
          <!--          >-->
<!--          <select class="form-control" id="selected-event" [(ngModel)]="participantToEdit.event" name="selected-event"-->
<!--                  [disabled]="!isAdmin()">-->
<!--            <option *ngFor="let c of events" [ngValue]="c">{{ c }}</option>-->
<!--          </select>-->
          <select class="form-control" id="selected-event" [(ngModel)]="participantToEdit.event" name="selected-event"
                  [disabled]="!isAdmin()">
            <option *ngFor="let c of events" [ngValue]="c">{{ c }}</option>
          </select>

        </div>
        <div *ngIf="isAdmin() && participantToEdit.eventId != eventId">
          <button type="button" class="btn btn-warning" [ngClass]="{'button-alert': !canEdited()}"
                  style="width: 100%; padding:0.8rem; margin-top: 20px; "
                  (click)="transferParticipant(participantToEdit)">
            Transfer Participant
          </button>
        </div>

        <div *ngIf="isSuperUser()">
          <button type="button" class="btn btn-warning" [ngClass]="{'button-alert': !canEdited()}"
                  style="width: 100%; padding:0.8rem; margin-top: 20px; "
                  (click)="assignCategoryForParticipant(participantToEdit)">
            Assign category
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" [ngClass]="{'button-alert': !canEdited()}"
            style="width: 100%; padding:0.8rem; "
            (click)="modal.close('Create click')">
      {{ getTextForApplyButton() }}
    </button>
  </div>
</ng-template>

<ng-template #editParticipantContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Редактирование участника
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body participant-edit-modal">
    <div class="mobile-participant-edit d-block d-md-none">
      <div class="participant-header">
        <div class="participant-name" *ngIf="!isAdmin()">
          {{ participantToEdit?.surname }} {{ participantToEdit.name }}
        </div>
        <div class="participant-event">{{ participantToEdit?.eventName }}</div>
        <div *ngIf="participantToEdit?.isFromOtherEvent" class="alert-badge">
          УЧАСТНИК ЗАРЕГИСТРИРОВАН НА ДРУГОЕ МЕРОПРИЯТИЕ
        </div>
      </div>

      <div class="participant-info" *ngIf="!isAdmin()">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Дистанция:</span>
            <span class="info-value">{{ getStringIfEmpty(participantToEdit.event) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Дата рождения:</span>
            <span class="info-value">{{ getStringIfEmpty(participantToEdit.dateOfBirth) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Категория:</span>
            <span class="info-value">{{ getStringIfEmpty(participantToEdit.category) }}</span>
          </div>
<!--          <div class="info-item">-->
<!--            <span class="info-label">Клуб:</span>-->
<!--            <span class="info-value">{{ getStringIfEmpty(participantToEdit.club) }}</span>-->
<!--          </div>-->
          <div class="info-item">
            <span class="info-label">Окончание выдачи:</span>
            <span class="info-value">{{ getEndOfflineRegistrationTime(participantToEdit) }}</span>
          </div>
        </div>
      </div>

      <form class="mobile-form">
        <div class="form-group" *ngIf="canEdited()">
          <label class="form-label">Номер участника</label>
          <input id="input-bib-mobile" name="bib" class="form-control mobile-input"
                 type="number" [disabled]="!canEdited()"
                 [(ngModel)]="participantToEdit.bib" [autofocus]="true">
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Tag</label>
          <input name="tag" class="form-control mobile-input" type="text"
                 [disabled]="!isAdmin()" [(ngModel)]="participantToEdit.tag">
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Фамилия</label>
          <input name="surname" class="form-control mobile-input"
                 [(ngModel)]="participantToEdit.surname">
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Имя</label>
          <input name="name" class="form-control mobile-input"
                 [(ngModel)]="participantToEdit.name">
        </div>

<!--        <div class="form-group" *ngIf="isAdmin()">-->
<!--          <label class="form-label">Клуб</label>-->
<!--          <input name="club" class="form-control mobile-input"-->
<!--                 [(ngModel)]="participantToEdit.club">-->
<!--        </div>-->

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Дата рождения</label>
          <input name="dateOfBirth" class="form-control mobile-input"
                 [(ngModel)]="participantToEdit.dateOfBirth">
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Пол</label>
          <select class="form-control mobile-select" [(ngModel)]="participantToEdit.gender"
                  name="selected-gender" [disabled]="!isAdmin()">
            <option *ngFor="let c of genders" [ngValue]="c">{{ c }}</option>
          </select>
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Категория</label>
          <select class="form-control mobile-select" [(ngModel)]="participantToEdit.category"
                  name="selected-category" [disabled]="!isAdmin()">
            <option *ngFor="let c of categories" [ngValue]="c">{{ c }}</option>
          </select>
        </div>

        <div class="form-group" *ngIf="isAdmin()">
          <label class="form-label">Event</label>
          <select class="form-control mobile-select" [(ngModel)]="participantToEdit.event"
                  name="selected-event" [disabled]="!isAdmin()">
            <option *ngFor="let c of events" [ngValue]="c">{{ c }}</option>
          </select>
        </div>

        <div class="form-group" *ngIf="isAdmin() && participantToEdit.eventId != eventId">
          <button type="button" class="btn btn-warning mobile-button transfer-button"
                  [ngClass]="{'button-alert': !canEdited()}"
                  (click)="transferParticipant(participantToEdit)">
            Transfer Participant
          </button>
        </div>
        <div class="form-group">
          <button type="button" class="btn btn-primary mobile-footer-button" style="width: 100%"
                  [ngClass]="{'button-alert': !canEdited()}"
                  (click)="modal.close('Create click')">
            {{ getTextForApplyButton() }}
          </button>
        </div>
      </form>
    </div>

    <div class="desktop-participant-edit d-none d-md-block">
      <form>
        <div class="form-group">
          <h5 *ngIf="!isAdmin()">
            {{ participantToEdit?.surname }} {{ participantToEdit.name }}
          </h5>
          <h6>Мероприятие: {{ participantToEdit?.eventName }}</h6>
          <h6 *ngIf="participantToEdit?.isFromOtherEvent" class="text-highlighted-alert">
            УЧАСТНИК ЗАРЕГИСТРИРОВАН НА ДРУГОЕ МЕРОПРИЯТИЕ
          </h6>
          <h6 *ngIf="!isAdmin()">Дистанция: {{ getStringIfEmpty(participantToEdit.event) }}</h6>
          <h6 *ngIf="!isAdmin()">Дата рождения: {{ getStringIfEmpty(participantToEdit.dateOfBirth) }}</h6>
          <h6 *ngIf="!isAdmin()">Категория: {{ getStringIfEmpty(participantToEdit.category) }}</h6>
          <h6 *ngIf="!isAdmin()">Телефон: {{ getStringIfEmpty(participantToEdit.phone) }}</h6>
          <h6>Старт: {{ getStartForParticipant(participantToEdit) }}</h6>
          <h6>Окончание выдачи: {{ getEndOfflineRegistrationTime(participantToEdit) }}</h6>

          <label class="label-black" *ngIf="canEdited()">Номер участника</label>
          <input id="input-bib" name="bib" class="form-control" type="number"
                 [disabled]="!canEdited()" *ngIf="canEdited()"
                 [(ngModel)]="participantToEdit.bib" [autofocus]="true">

          <div *ngIf="isAdmin()">
            <label class="label-black">Tag</label>
            <input name="tag" class="form-control" type="text" [disabled]="!isAdmin()"
                   [(ngModel)]="participantToEdit.tag">
          </div>
          <div *ngIf="isAdmin()">
            <label class="label-black">Event</label>
            <select class="form-control" [(ngModel)]="participantToEdit.event"
                    name="selected-event" [disabled]="!isAdmin()">
              <option *ngFor="let c of events" [ngValue]="c">{{ c }}</option>
            </select>
          </div>
          <div>
            <button type="button" class="btn btn-primary" style="width: 100%"
                    [ngClass]="{'button-alert': !canEdited()}"
                    (click)="modal.close('Create click')">
              {{ getTextForApplyButton() }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Выберите формат экспорта
    </h4>
    <button type="button" class="btn btn-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <div class="form-group mb-3">
        <label for="exportFormat">Формат экспорта</label>
        <select id="exportFormat" class="form-control" [(ngModel)]="selectedExportFormat">
          <option value="so-import">Импорт в спорторг</option>
          <option value="sportorg">Формат SportOrg CSV</option>
          <option value="copernico">Формат Copernico</option>
        </select>
      </div>

      <div class="form-group mb-3" style="display: flex; flex-direction: column; align-items: center; width: 100%;">
        <label for="dateFormat" style="text-align: center;">Формат даты</label>
        <input type="text" id="dateFormat" class="form-control"
               style="width: auto; text-align: center;padding-left: 2px; padding-right: 2px;"
               [(ngModel)]="currentDateFormat">
      </div>

      <div *ngFor="let _event of getEventsForDownload()" class="div-center">
        <button type="button" class="btn btn-outline-dark button-center"
                (click)="downloadCSVWithFormat(_event, selectedExportFormat)">
          Скачать {{ _event }}
        </button>
      </div>

      <div class="div-center">
        <button type="button" class="btn btn-outline-dark button-center"
                (click)="downloadCSVWithFormat('all', selectedExportFormat)">
          Скачать все дистанции
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #contentorient let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Выберите действие
    </h4>

    <button type="button" class="btn btn-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">
        ×
      </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <div *ngFor="let _event of events" class="div-center">
        <button type="button" class="btn btn-outline-dark button-center"
                (click)="downloadCSVWithEvent(_event)">
          Скачать {{ _event }}
        </button>
      </div>
      <div class="div-center">
        <button type="button" class="btn btn-outline-dark button-center"
                (click)="downloadCSVOrient()">
          Скачать все дистанции
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #massEdit let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Массовое редактирование</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="massEditForm" (ngSubmit)="onSubmitMassEdit(modal)">
      <div class="modal-footer">
        <button type="submit" class="button-main-blue">Сохранить</button>
        <button type="button" class="button-main-outline"
                (click)="modal.dismiss()">Отмена
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #statisticsContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ isIssuanceEvent ? 'Статистика выдачи номеров' : 'Статистика по участникам без номеров' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Статистика для типа issuance -->
    <div class="statistics-container" *ngIf="isIssuanceEvent">
      <div class="statistics-item">
        <span class="statistics-label">Всего участников:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().totalParticipants }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Всего номеров:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().totalBibs }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Выдано номеров:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().issuedBibs }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Не выдано номеров:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().notIssuedBibs }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Участников с входным билетом:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().participantsWithEntryTicket }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Участников без входного билета:</span>
        <span class="statistics-value">{{ getIssuanceStatistics().participantsWithoutEntryTicket }}</span>
      </div>
    </div>

    <!-- Статистика для обычных мероприятий -->
    <div class="statistics-container" *ngIf="!isIssuanceEvent">
      <div class="statistics-item">
        <span class="statistics-label">Всего участников:</span>
        <span class="statistics-value">{{ getStatistics().total }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Без номеров:</span>
        <span class="statistics-value">{{ getStatistics().withoutBib }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">C номером:</span>
        <span class="statistics-value">{{ (getStatistics().total - getStatistics().withoutBib) }}</span>
      </div>
      <div class="statistics-item">
        <span class="statistics-label">Стартовали:</span>
        <span class="statistics-value">{{ getStatistics().started }}</span>
      </div>
      <!-- Карточки статистики для issuance -->
      <div class="statistics-summary" *ngIf="isIssuanceEvent">
        <div class="stat-card">
          <mat-icon class="stat-icon">people</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getIssuanceStatistics().totalParticipants }}</div>
            <div class="stat-label">Всего участников</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon success">confirmation_number</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getIssuanceStatistics().issuedBibs }}</div>
            <div class="stat-label">Выдано номеров</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon warning">schedule</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getIssuanceStatistics().notIssuedBibs }}</div>
            <div class="stat-label">Не выдано</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon danger">error</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getIssuanceStatistics().participantsWithoutEntryTicket }}</div>
            <div class="stat-label">Без входного билета</div>
          </div>
        </div>
      </div>

      <!-- Карточки статистики для обычных мероприятий -->
      <div class="statistics-summary" *ngIf="!isIssuanceEvent">
        <div class="stat-card">
          <mat-icon class="stat-icon">people</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getStatistics().total }}</div>
            <div class="stat-label">Всего участников</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon warning">warning</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getStatistics().withoutBib }}</div>
            <div class="stat-label">Без номера</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon success">flag</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getStatistics().total - getStatistics().withoutBib }}</div>
            <div class="stat-label">С номером</div>
          </div>
        </div>
        <div class="stat-card">
          <mat-icon class="stat-icon success">check_circle</mat-icon>
          <div class="stat-content">
            <div class="stat-value">{{ getStatistics().started }}</div>
            <div class="stat-label">Стартовали</div>
          </div>
        </div>
      </div>

      <!-- Детальная статистика для issuance -->
      <div class="statistics-details" *ngIf="isIssuanceEvent">
        <div class="stat-section">
          <h5>По статусу выдачи</h5>
          <div class="stat-list">
            <div class="stat-item">
              <span class="stat-item-label">
                <mat-icon class="stat-item-icon success">check_circle</mat-icon>
                Полностью выдано
              </span>
              <span class="stat-item-value">{{ getIssuanceStatistics().byIssuanceStatus.issued }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-item-label">
                <mat-icon class="stat-item-icon warning">warning</mat-icon>
                Частично выдано
              </span>
              <span class="stat-item-value">{{ getIssuanceStatistics().byIssuanceStatus.partially_issued }}</span>
            </div>
            <div class="stat-item">
              <span class="stat-item-label">
                <mat-icon class="stat-item-icon muted">schedule</mat-icon>
                Не выдано
              </span>
              <span class="stat-item-value">{{ getIssuanceStatistics().byIssuanceStatus.not_issued }}</span>
            </div>
          </div>
        </div>

        <div class="stat-section">
          <h5>По дистанциям</h5>
          <div class="stat-list">
            <div *ngFor="let event of getIssuanceStatistics().byEvent | keyvalue" class="stat-item">
              <span class="stat-item-label">{{ event.key }}</span>
              <span class="stat-item-value">
                <span class="issued-count">{{ event.value.issued }}</span>/<span class="total-count">{{ event.value.total }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Детальная статистика для обычных мероприятий -->
      <div class="statistics-details" *ngIf="!isIssuanceEvent">
        <div class="stat-section">
          <h5>По категориям</h5>
          <div class="stat-list">
            <div *ngFor="let category of getStatistics().byCategory | keyvalue" class="stat-item">
              <span class="stat-item-label">{{ category.key }}</span>
              <span class="stat-item-value">{{ category.value }}</span>
            </div>
          </div>
        </div>

        <div class="stat-section">
          <h5>По дистанциям</h5>
          <div class="stat-list">
            <div *ngFor="let event of getStatistics().byEvent | keyvalue" class="stat-item">
              <span class="stat-item-label">{{ event.key }}</span>
              <span class="stat-item-value">{{ event.value.assigned }}/{{ event.value.total }}</span>
            </div>
          </div>
        </div>

        <div class="stat-section">
          <h5>По клубам</h5>
          <div class="stat-list">
            <div *ngFor="let category of getStatistics().byClub | keyvalue" class="stat-item">
              <span class="stat-item-label">{{ category.key }}</span>
              <span class="stat-item-value">{{ category.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #createParticipantContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Добавление участника</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="createParticipantForm">
      <div class="form-group mb-3">
        <label for="surname">Фамилия *</label>
        <input type="text" id="surname" formControlName="surname" class="form-control" required>
      </div>

      <div class="form-group mb-3">
        <label for="name">Имя *</label>
        <input type="text" id="name" formControlName="name" class="form-control" required>
      </div>

      <div class="form-group mb-3">
        <label for="club">Клуб</label>
        <input type="text" id="club" formControlName="club" class="form-control">
        <p style="margin-top: 2px; color: red" *ngIf="isClubNotUnique()">Клуб не уникален!</p>
      </div>

      <div class="form-group mb-3">
        <label for="phone">Телефон</label>
        <input type="tel" id="phone" formControlName="phone" class="form-control">
      </div>

      <div class="form-group mb-3">
        <label for="dateOfBirth">Дата рождения</label>
        <input id="dateOfBirth" formControlName="dateOfBirth" class="form-control">
      </div>

      <div class="form-group mb-3">
        <label for="category">Категория</label>
        <select id="category" formControlName="category" class="form-control">
          <option value="">Выберите категорию</option>
          <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
        </select>
      </div>

      <div class="form-group mb-3">
        <label for="event">Дистанция</label>
        <select id="event" formControlName="event" class="form-control" required>
          <option value="">Выберите дистанцию</option>
          <option *ngFor="let event of events" [value]="event">{{ event }}</option>
        </select>
      </div>

      <div class="form-group mb-3">
        <label for="bib">Номер участника</label>
        <input type="number" id="bib" formControlName="bib" class="form-control">
      </div>

      <div class="button-container">
        <button type="button" class="button-main-outline" (click)="modal.dismiss()">
          <mat-icon>close</mat-icon>
          Отмена
        </button>
        <button type="submit" class="button-main-blue" (click)="onSubmitCreateParticipant(createParticipantForm)">
          <mat-icon>save</mat-icon>
          Сохранить
        </button>
      </div>
    </form>
  </div>
</ng-template>
<ng-template #uploadContent let-modal class="modal-fullscreen">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-upload-title">
      Загрузить файл участников
    </h4>
    <button type="button" class="btn btn-danger" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>

  <div class="modal-body" style="width: 100%">
    <div class="form-group mb-3">
      <label for="fileInput" class="form-label">Выберите файл (CSV/XLSX):</label>
      <input type="file"
             class="form-control"
             id="fileInput"
             accept=".csv,.xlsx,.xls"
             (change)="onFileSelected($event)">
    </div>

    <div *ngIf="selectedFile" class="form-group mb-3">
      <div class="mb-3">
        <label class="form-label">Способ обработки столбцов:</label>
        <div class="form-check">
          <input class="form-check-input"
                 type="radio"
                 name="columnMode"
                 id="autoMode"
                 value="auto"
                 [(ngModel)]="columnMode">
          <label class="form-check-label" for="autoMode">
            Автоматически определить столбцы
          </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 type="radio"
                 name="columnMode"
                 id="manualMode"
                 value="manual"
                 [(ngModel)]="columnMode">
          <label class="form-check-label" for="manualMode">
            Сопоставить столбцы вручную
          </label>
        </div>
      </div>

      <div *ngIf="columnMode === 'manual' && fileColumns.length > 0" class="mb-3">
        <label class="form-label">Сопоставьте столбцы файла с полями участника:</label>

        <div class="mb-3">
          <button type="button"
                  class="btn btn-outline-primary btn-sm me-2"
                  (click)="autoMapColumns()">
            Автосопоставление
          </button>
          <button type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="clearColumnMapping()">
            Очистить сопоставление
          </button>
        </div>

        <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-sm table-bordered">
            <thead class="table-light">
            <tr>
              <th style="width: 30%">Столбец в файле</th>
              <th style="width: 40%">Поле участника</th>
              <th style="width: 30%">Пример данных</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let column of fileColumns; let i = index">
              <td>
                <strong>{{ column.name }}</strong>
              </td>
              <td>
                <select class="form-select form-select-sm"
                        [(ngModel)]="column.mappedField"
                        (change)="onColumnMappingChange()">
                  <option value="">-- Не импортировать --</option>
                  <option *ngFor="let field of participantFields"
                          [value]="field.key"
                          [disabled]="isFieldAlreadyMapped(field.key, i)">
                    {{ field.displayName }}
                    <span *ngIf="field.required" class="text-danger">*</span>
                  </option>
                </select>
                <small *ngIf="column.mappedField" class="text-muted d-block">
                  {{ getFieldDescription(column.mappedField) }}
                </small>
              </td>
              <td>
                <small class="text-muted">
                  {{ getColumnPreview(i) }}
                </small>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div *ngIf="getMappingWarnings().length > 0" class="alert alert-warning">
          <strong>Внимание:</strong>
          <ul class="mb-0">
            <li *ngFor="let warning of getMappingWarnings()">{{ warning }}</li>
          </ul>
        </div>
      </div>

      <div *ngIf="previewData.length > 0" class="mb-3">
        <label class="form-label">Предварительный просмотр:</label>
        <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
          <table class="table table-sm table-bordered">
            <thead>
            <tr>
              <th *ngFor="let header of previewHeaders">{{ header }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of previewData.slice(0, 5)">
              <td *ngFor="let cell of row">{{ cell }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <small class="text-muted">Показаны первые 5 строк</small>
      </div>
    </div>

    <div class="div-center">
      <button type="button"
              class="btn btn-outline-secondary me-2"
              (click)="modal.dismiss('Cancel')">
        Отмена
      </button>
      <button type="button"
              class="btn btn-primary"
              [disabled]="!canUpload()"
              (click)="uploadFile(modal)">
        Загрузить
      </button>
    </div>
  </div>
</ng-template>

<ng-template #issuanceContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-issuance-title">
      Выдача номера участника
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="participant-info">
      <h5>{{ issuanceParticipant.surname }} {{ issuanceParticipant.name }}</h5>
      <p><strong>Дата рождения:</strong> {{ issuanceParticipant.dateOfBirth }}</p>
      <p><strong>Пол:</strong> {{ issuanceParticipant.gender }}</p>
      <p><strong>Клуб:</strong> {{ issuanceParticipant.club || 'Не указан' }}</p>
      <p><strong>Телефон:</strong> {{ issuanceParticipant.phone || 'Не указан' }}</p>
<!--      <p><strong>Категория:</strong> {{ issuanceParticipant.category }}</p>-->

      <!-- Отображение всех номеров участников из всех дисциплин -->
      <div *ngIf="issuanceParticipant.allBibNumbers && issuanceParticipant.allBibNumbers.length > 0" class="bib-numbers-section">
        <p><strong>Номера:</strong></p>
        <div class="bib-numbers-list">
          <span *ngFor="let bibItem of issuanceParticipant.allBibNumbers" class="bib-number-badge" [class.issued]="bibItem.issuanceStatus === 'issued'">
            {{ bibItem.bib }} ({{ bibItem.event }})
            <mat-icon *ngIf="bibItem.issuanceStatus === 'issued'" class="issued-icon" title="Выдано">check_circle</mat-icon>
          </span>
        </div>
      </div>
    </div>

<!--    <div class="form-group">-->
<!--      <label for="bib">Номер участника:</label>-->
<!--      <input type="number" id="bib" class="form-control" [(ngModel)]="issuanceParticipant.bib" required>-->
<!--    </div>-->

<!--    <div class="form-group">-->
<!--      <label for="tag">Tag:</label>-->
<!--      <input type="text" id="tag" class="form-control" [(ngModel)]="issuanceParticipant.tag" required>-->
<!--    </div>-->
<!--    -->
    <div class="form-group">
      <label>Дистанции:</label>
      <div class="checkbox-group">
        <div *ngFor="let event of issuanceParticipant.selectedEvents" class="checkbox-item">
          <input
            type="checkbox"
            [id]="'event-' + event.name"
            [(ngModel)]="event.selected"
            [disabled]="event.disabled"
            class="form-check-input">
          <label [for]="'event-' + event.name" class="form-check-label" [class.disabled-label]="event.disabled">
            {{ event.name }}
            <span *ngIf="event.participantIds && event.participantIds.length > 0" class="participant-ids">
              (ID: {{ event.participantIds.join(', ') }})
            </span>
            <span class="event-status" *ngIf="getEventStatusIcon(getEventStatus(event, issuanceParticipant.allBibNumbers))">
              <mat-icon [class]="getEventStatusColor(getEventStatus(event, issuanceParticipant.allBibNumbers))"
                       [title]="getEventStatusText(getEventStatus(event, issuanceParticipant.allBibNumbers))">
                {{ getEventStatusIcon(getEventStatus(event, issuanceParticipant.allBibNumbers)) }}
              </mat-icon>
            </span>
          </label>
        </div>
      </div>
    </div>

    <div class="button-container">
      <button type="button" class="button-main-outline" (click)="modal.dismiss()">
        <mat-icon>close</mat-icon>
        Отмена
      </button>
      <button type="button" class="button-main-blue" (click)="onSubmitIssuance(issuanceParticipant, modal)">
        <mat-icon>save</mat-icon>
        Выдать
      </button>
    </div>
  </div>
</ng-template>


<style>
  .custom-checkbox {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  .custom-checkbox-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }

  .checkbox-column {
    width: 50px;
    text-align: center;
  }

  .number-column {
    width: 70px;
    text-align: center;
  }

  .name-column {
    width: 200px;
    text-align: left;
  }

  .mobile-table {
    width: 100%;
    min-width: 300px;
  }

  @media screen and (max-width: 576px) {
    .hide-on-mobile {
      display: none;
    }

    .mobile-table {
      font-size: 14px;
    }

    .checkbox-column {
      width: 40px;
    }

    .number-column {
      width: 50px;
    }

    .name-column {
      width: 100px;
    }

    .custom-checkbox {
      width: 24px;
      height: 24px;
    }

    .modal-body {
      padding: 10px;
    }

    .table-responsive {
      margin: -10px;
    }

    .table td, .table th {
      padding: 8px 4px;
    }
  }
</style>


